function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.774 2h6.405a1 1 0 0 1 1 1v14.056a1 1 0 0 1-1 1H4.774a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zm-.751 4.399h5.755-5.755zm0-1.956h5.755-5.755zm0 4.05h4.061-4.061zm0 2.094h4.061-4.061zm0 2.094H6.72 4.023z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.68 6.722a1 1 0 0 1 1 1v9.334a1 1 0 0 1-1 1h-3.455c-.552 0-.068-.448-.068-1 0-.369.008-3.027.024-7.976 0-.552-.005-1.062 0-2.358h3.5zm.738 2.079h-4.116 4.116zm0 1.889h-4.031 4.03zm0 1.888h-2.679 2.679z"
}));

const SvgLocations = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLocations, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/locations.52221c9c.svg";
export { ForwardRef as ReactComponent };